import Vue from 'vue';
import store from './store';

import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css';
import VuePaginate from 'vue-paginate';

// JN - 20210617
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { faClone } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faExclamation } from '@fortawesome/free-solid-svg-icons'
import { faCheckDouble } from '@fortawesome/free-solid-svg-icons'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { faUpload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import Face from "./Components/Face/main.vue";

library.add(faBars)
library.add(faCalendarAlt)
library.add(faArrowCircleLeft)
library.add(faCog)
library.add(faTimes)
library.add(faClone)
library.add(faPlus)
library.add(faMinus)
library.add(faExclamation)
library.add(faCheckDouble)
library.add(faEdit)
library.add(faUpload)

Vue.use(datePicker);
Vue.use(BootstrapVue)

Vue.component("font-awesome-icon", FontAwesomeIcon)
Vue.component("face", Face);

Vue.use(VuePaginate);
//Vue.use(store);

window.event = new Vue();

new Vue({
    store,
    render: h => h(Face)
}).$mount('#canvas');
